import { render, staticRenderFns } from "./Pricelist.vue?vue&type=template&id=5678a362&scoped=true&"
import script from "./Pricelist.vue?vue&type=script&lang=js&"
export * from "./Pricelist.vue?vue&type=script&lang=js&"
import style0 from "./Pricelist.vue?vue&type=style&index=0&id=5678a362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5678a362",
  null
  
)

export default component.exports